var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.71422V3.52672C0 3.291 0.09 3.08475 0.27 2.90797C0.45 2.73118 0.66 2.64279 0.9 2.64279H3V1.16957C3 0.933859 3.09 0.727609 3.27 0.550823C3.45 0.374037 3.66 0.285645 3.9 0.285645H8.1C8.34 0.285645 8.55 0.374037 8.73 0.550823C8.91 0.727609 9 0.933859 9 1.16957V2.64279H11.1C11.34 2.64279 11.55 2.73118 11.73 2.90797C11.91 3.08475 12 3.291 12 3.52672V9.71422H0ZM0.9 8.83029H11.1V6.62047H9.45V7.20975H8.55V6.62047H3.45V7.20975H2.55V6.62047H0.9V8.83029ZM0.9 3.52672V5.73654H2.55V5.14725H3.45V5.73654H8.55V5.14725H9.45V5.73654H11.1V3.52672H0.9ZM3.9 2.64279H8.1V1.16957H3.9V2.64279Z",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbox);
export default __webpack_public_path__ + "static/media/toolbox.b1fe5315e7bbf6064637a6a8033e8899.svg";
export { ForwardRef as ReactComponent };